import axios from 'axios';
import {
  CaseBuildingPlotModel,
  PlotBeingCreatedModel
} from 'app/edozvola/cases/case-building-plot/model/case-building-plot-form.model';
import { DkpLocationModel } from 'app/edozvola/cases/case-location/model/case-location.model';

const caseBaseUrl = '/api/cases';

export const fetchCaseBuildingPlot = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/building-plot`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseBuildingPlot = async (idCase: string, values: CaseBuildingPlotModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/building-plot`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchAllDkpLocations =  async (idCase: string): Promise<DkpLocationModel[]> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`${caseBaseUrl}/${idCase}/dkp-locations/fetch-all`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
}

export const savePlotBeingCreated = async (idCase: string, values: PlotBeingCreatedModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/plot-being-created/${idCase}`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchPlotBeingCreated = async (idPlotBeingCreated: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/plot-being-created/${idPlotBeingCreated}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchAllPlotBeingCreated = async (idCase: string, page: number, size: number, column: string, direction: string): Promise<any> => {
  if (idCase) {
    return await new Promise(resolve => {
      axios
        .get(`api/plot-being-created/find-all/${idCase}?page=${page}&size=${size}&column=${column}&direction=${direction}`)
        .then(response => resolve(response.data));
    });
  }
};


export const deletePlotBeingCreated = async (idPlotBeingCreated: string): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .delete(`api/plot-being-created/${idPlotBeingCreated}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};

export const fetchCaseBuildingPlotGeometryStatus = async (idCase: string): Promise<boolean> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/building-plot/geometry-status`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};
